/**
 * @file: presence.ts
 *
 * Helpers for the app-wide user-presence ("online") signal. The session
 * holds a flat set of online identity keys; this is the single place that
 * derives that key so the write (live event / query merge) and the read
 * (`useIsOnline`) never drift. Key shape mirrors the backend presence key.
 */

import { UserPresenceRef } from '@euler/model/chat';

export function presenceKeyOf(ref: UserPresenceRef): string {
  return `${ref.appId}|${ref.appScope}|${ref.platformUserId}`;
}
